<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">List of organizations enrolled</p>
      </div>

      <div class="m-2">
        <org-tabs :updateOrgList="updateOrgList" v-if="searchInput"></org-tabs>
        <org-tabs
          :updateOrgList="updateOrgList"
          v-if="!searchInput.length"
        ></org-tabs>
      </div>
      <div class="flex justify-between mt-0">
        <!-- search -->
        <input
          v-model="searchInput"
          type="search"
          placeholder="Start typing to search..."
          class="p-2 bg-gray-200 w-52 m-2 mb-0 pl-2 py-1 rounded-md"
        />
        <!-- search -->
        <div
          @click="exportTemplate"
          class="bg-primary flex text-white items-center text-sm px-3 cursor-pointer gap-2 rounded-md m-2 mb-0 pl-2 py-1"
        >
          <img class="h-5" src="@/assets/icons/export-excel.png" />
          <p>Export</p>
        </div>
      </div>

      <div class="p-2 relative">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ success_msg }}
          </div>
        </transition>
        <!-- <org-tabs :updateOrgList="updateOrgList" v-if="searchInput"></org-tabs> -->
        <ve-table
          v-if="searchInput"
          :columns="columns"
          :table-data="filteredTableData"
        />

        <!-- <org-tabs :updateOrgList="updateOrgList" v-if="!searchInput.length"></org-tabs> -->
        <ve-table
          :columns="columns"
          :table-data="tableData"
          v-if="!searchInput.length"
        />

        <p
          v-if="searchInput.length && filteredTableData.length === 0"
          class="text-center py-3"
        >
          No results
        </p>
        <list-paginator
          :current-page="currentPage"
          :total-pages="totalPages"
          @page-changed="onPageChanged"
        >
        </list-paginator>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <review
      :showReviewOrganization="showReview"
      :organizationData="rowToReview"
      @handleSuccess="handleSuccess"
      @close="close()"
    ></review>
  </div>
</template>

<script>
import Review from "@/components/requests/review.vue";
import Loader from "../components/loader/loader.vue";
import OrgTabs from "./orgTabs.vue";
//import sidebavmenu from "@/components/table/menu.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import { utils, writeFileXLSX } from "xlsx";
import ListPaginator from "../utils/listPaginator.vue";
export default {
  name: "Organizations",
  components: { Review, Loader, OrgTabs, ListPaginator },
  data() {
    return {
      rowToReview: false,
      showReview: false,
      loading: false,
      get_error: null,
      showSuccess: false,
      searchInput: "",
      success_msg: null,
      currentTab: "Active",
      currentPage: 1,
      pageSize: 5,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "Name",
          key: "a",
          title: "Organization",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Email",
          key: "b",
          title: "Company Email",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "Phonenumber",
          key: "c",
          title: "Phone",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "TotalManagers",
          key: "x",
          title: "Managers",
        },
        {
          field: "TotalNormalEmployees",
          key: "xy",
          title: "Employees",
        },
        {
          field: "SubscriptionStatus",
          key: "xs",
          title: "Subscription Status",
          renderBodyCell: ({ row }) => {
            return row.SubscriptionStatus.toLowerCase() === "trial" ? (
              <p class="text-red-900 bg-red-200 p-1 pl-2 rounded-md  w-20 mx-auto pl-2 rounded-md">
                {row.SubscriptionStatus}
              </p>
            ) : (
              <p class="text-green-900 bg-green-200 p-1 pl-2 rounded-md w-20 mx-auto">
                {row.SubscriptionStatus}
              </p>
            );
          },
        },

        {
          field: "Disabled",
          key: "xss",
          title: "Disabled",
          renderBodyCell: ({ row }) => {
            return row.Disabled ? (
              <p class="text-red-900 bg-red-200 p-1 pl-2 rounded-md w-20 mx-auto">
                Yes
              </p>
            ) : (
              <p class="text-green-900 bg-green-200 p-1 pl-2 rounded-md w-20 mx-auto">
                No
              </p>
            );
          },
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  on-click={() => this.openReview(row)}
                >
                  View
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => {}}
                >
                  Activate
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            //console.log(item['RemainingEmployee'])
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    totalPages() {
      return Math.ceil(this.tableData.length / this.pageSize);
    },
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.tableData.slice(startIndex, endIndex);
    },
  },
  created() {
    this.getOrganizations(this.currentTab);
  },
  methods: {
    close() {
      this.rowToReview = null;
      this.showReview = false;
    },
    openReview(row) {
      this.rowToReview = row;
      this.showReview = true;
    },
    handleSuccess(message) {
      this.rowToReview = null;
      this.showReview = false;
      this.success_msg = message;
      this.showSuccess = true;
      setTimeout(() => {
        this.showSuccess = false;
      }, 3000);
      this.getOrganizations(this.currentTab);
    },
    getOrganizations(currentTab) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`organization/${this.$ApiVersion}/request`, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.tableData = response.data.Data.filter((item) => item.Approved);
            if (currentTab.trim() === "Trial") {
              this.tableData = this.tableData.filter(
                (entry) => entry.SubscriptionStatus === "Trial"
              );
            } else if (currentTab.trim() === "Active") {
              this.tableData = this.tableData.filter(
                (entry) => entry.SubscriptionStatus === "Active"
              );
            }
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.get_error = error.message;
        }
      );
    },

    exportTemplate() {
      const ws = utils.json_to_sheet(this.tableData);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Data");

      writeFileXLSX(wb, "organizations.xlsx");
    },
    updateOrgList(currentTab) {
      this.currentTab = currentTab;
      this.getOrganizations(currentTab);
    },
  },
};
</script>
